/**
 * ideally we'll have a central location for types like this
 * that could be generated from swagger or something on the backend
 * but for now these are just pulled from the test file in this dir.
 */
export interface Collection {
  date_published?: string;
  id?: number;
  root_text_set?: {
    id?: number;
  };
  slug: string;
  title?: string;
  subject?: string;
  is_subject_product?: boolean;
  is_branded_product?: boolean;
  icon?: unknown;
  is_custom?: boolean;
  image?: string | null;
}

export const getCollectionPathname = (collection: Collection) => {
  if (!collection?.subject || !collection?.root_text_set?.id) return;
  const formattedSubject = collection.subject.replace("_", "-");
  return `/subject/${formattedSubject}/${collection.root_text_set.id}`;
};

export const customCollections = (collections: Collection[]) =>
  (collections || []).filter((collection) => {
    return collection.is_custom && getCollectionPathname(collection);
  });

export const getPersonalizedSubjectAreaCollections = (
  collections: Collection[],
) =>
  (collections || []).filter(({ slug }) => {
    return ["social-emotional-learning", "lgbtqia-ss"].includes(slug);
  });
